<template>
  <div
    v-if="loading"
    class="loading-overlay"
  >
    <div>
      <ImageComponent
        :src="logoImage"
        :alt="'Logo'"          
        class="mt-5"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useLoadingStore } from '@/stores/useLoadingStore';
import { storeToRefs } from 'pinia';
import ImageComponent from '@/components/shared/ImageComponent.vue';
import logoImage from '@/assets/logo_inverse.svg';


export default defineComponent({
  name: 'LoadingComponent',
  components: {
    ImageComponent,  
  },
  setup() {
    const loadingStore = useLoadingStore();
    const { loading } = storeToRefs(loadingStore);
    return { loading };
  }, 
  data() {
    return {
      logoImage: logoImage,
    };
  }
});
</script>

<style scoped lang="scss">
.loading-overlay {
  background: #2D3032;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed; 
  width: 100%;
  height: 100%; 
  top: 0;
  left: 0;
  z-index: 9999;
}


</style>
